var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnmatchedReplies01 = function SvgUnmatchedReplies01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "unmatched_replies-01_svg2__a",
    x1: 60.63,
    x2: 214.23,
    y1: 212.68,
    y2: 77.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unmatched_replies-01_svg2__a",
    id: "unmatched_replies-01_svg2__b",
    x1: 39.88,
    x2: 193.48,
    y1: 189.18,
    y2: 53.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unmatched_replies-01_svg2__a",
    id: "unmatched_replies-01_svg2__c",
    x1: -11.49,
    x2: 142.11,
    y1: 130.95,
    y2: -4.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unmatched_replies-01_svg2__a",
    id: "unmatched_replies-01_svg2__d",
    x1: 50.26,
    x2: 203.86,
    y1: 200.93,
    y2: 65.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unmatched_replies-01_svg2__a",
    id: "unmatched_replies-01_svg2__e",
    x1: -6.45,
    x2: 147.15,
    y1: 136.67,
    y2: 1.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unmatched_replies-01_svg2__a",
    id: "unmatched_replies-01_svg2__f",
    x1: 59.35,
    x2: 212.95,
    y1: 211.24,
    y2: 75.71
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unmatched_replies-01_svg2__a",
    id: "unmatched_replies-01_svg2__g",
    x1: 2.31,
    x2: 155.91,
    y1: 146.59,
    y2: 11.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unmatched_replies-01_svg2__a",
    id: "unmatched_replies-01_svg2__h",
    x1: -14.51,
    x2: 139.09,
    y1: 127.54,
    y2: -7.99
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unmatched_replies-01_svg2__a",
    id: "unmatched_replies-01_svg2__i",
    x1: 18.16,
    x2: 171.76,
    y1: 164.56,
    y2: 29.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unmatched_replies-01_svg2__a",
    id: "unmatched_replies-01_svg2__j",
    x1: 18.24,
    x2: 171.84,
    y1: 164.64,
    y2: 29.11
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M109.85 148.14h55.16c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23h-55.16c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23",
    style: {
      fill: "url(#unmatched_replies-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85 106.34h55.16c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23h-55.16c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23",
    style: {
      fill: "url(#unmatched_replies-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.47 129.01H53.93c-.88 0-1.72.36-2.33.99l-20.53 21.38v-19.14c0-1.78-1.44-3.23-3.23-3.23H16.56c-5.57 0-10.11-4.52-10.11-10.09v-66.8c0-5.57 4.54-10.11 10.11-10.11h84.04c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23H16.56C7.44 35.56 0 43 0 52.12v66.8c0 9.12 7.44 16.54 16.56 16.54h8.05v23.93c0 1.32.8 2.5 2.02 2.99s2.62.19 3.53-.76l25.13-26.16h13.17c1.78 0 3.23-1.45 3.23-3.23S70.24 129 68.46 129Z",
    style: {
      fill: "url(#unmatched_replies-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85 127.24h55.16c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23h-55.16c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23",
    style: {
      fill: "url(#unmatched_replies-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.51 85.76c0-1.78-1.45-3.23-3.23-3.23H29.21c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23h44.07c1.78 0 3.23-1.45 3.23-3.23",
    style: {
      fill: "url(#unmatched_replies-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.48 160.46c7.25-10.21 11.52-22.69 11.52-36.18 0-11.15-2.92-21.61-8.02-30.67a3.23 3.23 0 0 0-4.39-1.23c-1.55.87-2.1 2.84-1.23 4.39 4.58 8.13 7.19 17.51 7.19 27.51 0 12.61-4.15 24.23-11.17 33.59-.59.79-.79 1.81-.53 2.77l6.74 25.18-31.38-8.4c-.61-.16-1.25-.14-1.85.06a56.5 56.5 0 0 1-17.92 2.92c-28.44 0-51.94-21.15-55.61-48.58-.33-2.46-.5-4.97-.5-7.53 0-18.68 9.13-35.22 23.16-45.42a3.23 3.23 0 0 0-3.8-5.22c-15.65 11.37-25.82 29.82-25.82 50.64 0 2.84.19 5.64.56 8.39 4.1 30.59 30.3 54.18 62.01 54.18 6.64 0 13.02-1.05 19.03-2.95l35.85 9.6c1.11.3 2.3-.02 3.12-.83.81-.81 1.13-2 .83-3.12l-7.79-29.08Z",
    style: {
      fill: "url(#unmatched_replies-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.37 110.13c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23H29.21c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23h36.15Z",
    style: {
      fill: "url(#unmatched_replies-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.21 61.37c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23h55.24c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23z",
    style: {
      fill: "url(#unmatched_replies-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.22 89.68c22.8 0 41.65-18.85 41.65-41.65 0-14.47-7.45-27.62-19.73-35.51-2.19-1.32-4.82-.44-6.14 1.32-1.32 2.19-.44 4.82 1.31 6.14 9.64 6.14 15.34 16.66 15.34 28.06 0 17.97-14.9 32.88-32.88 32.88s-32.44-14.91-32.44-32.88 14.91-32.88 32.88-32.88c2.63 0 4.38-1.75 4.38-4.38s-1.75-4.38-4.38-4.38c-22.8 0-41.65 18.85-41.65 41.65s18.85 41.65 41.65 41.65Z",
    style: {
      fill: "url(#unmatched_replies-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.82 47.92A5.08 5.08 0 0 0 134.9 53h31.25c2.81 0 5.08-2.28 5.08-5.08s-2.28-5.08-5.08-5.08H134.9a5.08 5.08 0 0 0-5.08 5.08",
    style: {
      fill: "url(#unmatched_replies-01_svg2__j)"
    }
  }));
};
export default SvgUnmatchedReplies01;